import { apiSlice } from 'store/slices/api/api-slice';
import {
    CreateItemRequest,
    EditItemRequest,
    ItemListResponse,
} from 'types/toont-tint/tool-tint-item';

export const toonTintItemApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        createToonTintItem: builder.mutation<void, CreateItemRequest>({
            query: (createItemRequest: CreateItemRequest) => ({
                url:
                    `toon-tint/category-item-save/` +
                    createItemRequest.categoryId,
                method: 'POST',
                body: createItemRequest,
            }),
        }),

        editItemToonTint: builder.mutation<void, EditItemRequest>({
            query: (editItemRequest: EditItemRequest) => ({
                url: `/toon-tint/category-item-update/${editItemRequest.itemId}`,
                method: 'PUT',
                body: { ...editItemRequest },
            }),
        }),

        toonTintItemList: builder.query<ItemListResponse[], string>({
            query: (categoryId) => ({
                url: '/toon-tint/category-item-list/' + categoryId,
                method: 'GET',
            }),
        }),

        getItemIdData: builder.query<ItemListResponse, string>({
            query: (params: string) => ({
                url: `toon-tint/category-item/${params}`,
                method: 'GET',
            }),
        }),
    }),
});

export const {
    useCreateToonTintItemMutation,
    useEditItemToonTintMutation,
    useLazyToonTintItemListQuery,
    useGetItemIdDataQuery,
} = toonTintItemApi;
